import { render, staticRenderFns } from "./ActLottery.vue?vue&type=template&id=1dbd384a&scoped=true"
import script from "./ActLottery.vue?vue&type=script&lang=js"
export * from "./ActLottery.vue?vue&type=script&lang=js"
import style0 from "./ActLottery.vue?vue&type=style&index=0&id=1dbd384a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbd384a",
  null
  
)

export default component.exports